import _find from "lodash/find"
import _remove from "lodash/remove"

export default class Popup {
    constructor(info){
        // 查询是否存在相同id的信息框，如果有，则移动位置，否则创建新的
        let pop=_find(Popup.instanceArray,function(p){
            return p.id==info.id||"";
        });

        // 如果存在，则直接返回
        let _this=null;

        if(pop){
            _this=pop;
        }else{
            _this = this;
            let dom=document.createElement("div");
            dom.className="div-point-container";
            dom.id=info.id||"popup_" +_this.__proto__.id++;
            _this.ctn=dom;
            _this.viewer = info.viewer;//弹窗创建的viewer
            _this.viewer.container.appendChild(_this.ctn);
        }
        _this.id =info.id||"popup_" +_this.__proto__.id++; // id号

        _this.geometry = info.geometry; //弹窗挂载的位置

        let name=info.name||"";
        let fields=info.fields||[{"label":"","num":"","unit":""}];
        // 是否显示关闭按钮
        let close=info.close||false;
        _this.onClose=info.onClose||info.onclose||false;
        // 属性内容
        let content=info.content||"";
        // 判断传入的内容，如果是一个dom节点，择克隆后作为内容显示
        _this.isDomExist=false;
        if(_this.isDom(content)){
            content=true;
            _this.isDomExist=true;
        }
        // 创建属性框的html
        _this.ctn.innerHTML=_this.createHtml(name,fields,content,close);
        // 如果节点已经存在了，择直接进行插入节点，不在创建新的节点
        if(_this.isDomExist){
            let contentWrap=_this.ctn.querySelector(".label-content");
            contentWrap.innerHTML='';
            info.content.style.display="block";
            contentWrap.appendChild(info.content);
        }


        if(close){
            _this.ctn.querySelector(".close").addEventListener("click",function(){
                _this.close();
            });
        }
        _this.render(_this.geometry);
        // 进行渲染
        if(!pop){
            // 绑定渲染事件
            _this.eventListener = _this.viewer.clock.onTick.addEventListener(function() {
                _this.render(_this.geometry);
            });
            // 保存引用
            Popup.instanceArray.push(_this);
        }
    }
    // 判断对象是否为dom
    isDom(dom){
        let isDom= typeof HTMLElement === 'object'? function(dom) {
            return dom instanceof HTMLElement;
        }: function(dom) {
            return dom && typeof dom === 'object' && dom.nodeType === 1 && typeof 	dom.nodeName === 'string';
        };
        return isDom(dom);
    }
    // 渲染相关内容
    render(geometry){
        let _this = this;
        let position = Cesium.SceneTransforms.wgs84ToWindowCoordinates(_this.viewer.scene,geometry);
        if(position){
            _this.ctn.style.display="block";
            _this.ctn.style.left=(position.x)+"px";
            _this.ctn.style.top=(position.y- _this.ctn.offsetHeight - 10)+"px";
        }

    }
    // 创建html
    createHtml(name,fileds,htmlContent,close){
        // 上班部分
        let html = '<div class="divpoint divpoint-theme">'+
                '<div class="divpoint-wrap">'+
                    '<div class="area">'+
                        '<div class="arrow-lt"></div>'+
                        '<div class="b-t"></div>'+
                        '<div class="b-r"></div>'+
                        '<div class="b-b"></div>'+
                        '<div class="b-l"></div>'+
                        '<div class="arrow-rb"></div>'+
                        '<div class="label-wrap">';
        if(close){
            html+='<div class="close"><i class="iconfont">&#xe618;</i></div>';
        }
        // 标题
        html+='<div class="title">'+name+'</div>';

        html+='<div class="label-content">';
        // label-content中的内容
        if(htmlContent){
            html+=htmlContent;
        }else{
            let fieldsHtml="";
            if(fileds){
                for(let f of fileds){
                    let label=f.label||"";
                    let num=f.num||"";
                    let unit=f.unit||"";
                    fieldsHtml+='<div class="data-li">'+
                        '<div class="data-label">'+label+'：</div>'+
                        '<div class="data-value">'+
                            '<span class="label-num">'+num+'</span>'+
                            '<span class="label-unit">'+unit+'</span>'+
                        '</div>'+
                    '</div>';
                }
            }
            html+=fieldsHtml;
        }
        // 下半部分       
                       html+='</div>'+
                        '</div>'+
                    '</div>'+
                '<div class="b-t-l"></div>'+
                '<div class="b-b-r"></div>'+
                '</div>'+
                '<div class="arrow"></div>'+
            '</div>';
        
        return html;
    }
    close(){
        let _this = this;
        // 取消事件监听
         _this.eventListener();
        // 如果传入的是一个已经存在的dom
        if(_this.isDomExist){
            _this.ctn.style.display="none";
        }else{
            _this.ctn.parentNode.removeChild(_this.ctn);
        }

        // 执行回调函数
        if(typeof _this.onClose == 'function')(
            _this.onClose()
        )

        // 从对象数组中移除该对象
        _remove(Popup.instanceArray,function(item){
            return item.id==_this.id;
        });
    }
}

// 静态属性
Popup.instanceArray=[];
Popup.id=0;